export default "__VITE_ASSET__DdQ2u2SH__"